import { GetRatePerPaxModel } from "@factory/model/query-model-rate-per-pax";
import { useDateTimeContext } from "@shared/utility/date-time-service/date-time.context";

import { ratePerPaxFormDefault } from "./form.default";
import { RatePerPaxFormSchema } from "./form.rule";

export const useFormDefaultRatePerPax = () => {
  const { formatDate } = useDateTimeContext();

  const getDefault = (cachedValue: GetRatePerPaxModel | undefined) => {
    return !cachedValue
      ? ratePerPaxFormDefault
     : ({
        activity: cachedValue.activity,
        number: cachedValue.number,
        childRate: cachedValue.child_rate,
        sizeDescription: cachedValue.size_description,
        amount: cachedValue.amount,
        totalAmount: cachedValue.total_amount,
      } as RatePerPaxFormSchema);
  };

  return {
    getDefault,
  };
};
